import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getProduct, getProducts, money } from "../api";
import { useCart } from "../context/CartContext";
import ProductCard from "../components/ProductCard";

export default function Product() {
  const { slug } = useParams();
  const { add } = useCart();
  const [product, setProduct] = useState(null);
  const [related, setRelated] = useState([]);
  const [qty, setQty] = useState(1);
  const [error, setError] = useState("");
  const [added, setAdded] = useState(false);

  useEffect(() => {
    let alive = true;
    setQty(1);
    setAdded(false);
    (async () => {
      try {
        const p = await getProduct(slug);
        if (!alive) return;
        setProduct(p);
        setError("");
        if (p.category_slug) {
          const list = await getProducts({ category: p.category_slug, limit: 4 });
          if (alive) setRelated(list.filter((x) => x.id !== p.id));
        }
      } catch (e) {
        if (alive) {
          setProduct(null);
          setError(e.message);
        }
      }
    })();
    return () => {
      alive = false;
    };
  }, [slug]);

  if (error) {
    return (
      <div className="empty-state">
        <h2>Product not found</h2>
        <p>{error}</p>
        <Link className="btn btn-primary" to="/shop">
          Back to shop
        </Link>
      </div>
    );
  }

  if (!product) {
    return <div className="empty-state">Loading…</div>;
  }

  const onAdd = () => {
    add(product, qty);
    setAdded(true);
    setTimeout(() => setAdded(false), 2000);
  };

  return (
    <>
      <div className="container product-detail">
        <div className="product-gallery">
          <img src={product.image} alt={product.name} />
        </div>
        <div className="product-info">
          <p className="breadcrumb">
            <Link to="/shop">Shop</Link>
            {product.category_slug && (
              <>
                {" / "}
                <Link to={`/shop?category=${product.category_slug}`}>{product.category}</Link>
              </>
            )}
          </p>
          {product.featured && <span className="pill">Featured</span>}
          <h1>{product.name}</h1>
          <p className="price-lg">{money(product.price)}</p>
          {product.description && <p className="desc">{product.description}</p>}

          <div className="qty-row">
            <div className="qty-control">
              <button type="button" onClick={() => setQty((q) => Math.max(1, q - 1))} aria-label="Decrease">
                −
              </button>
              <input
                type="number"
                min={1}
                max={99}
                value={qty}
                onChange={(e) => setQty(Math.max(1, Math.min(99, Number(e.target.value) || 1)))}
              />
              <button type="button" onClick={() => setQty((q) => Math.min(99, q + 1))} aria-label="Increase">
                +
              </button>
            </div>
            <button type="button" className="btn btn-primary" onClick={onAdd}>
              {added ? "Added ✓" : "Add to cart"}
            </button>
          </div>

          <p className="pickup-note">
            Pickup at 1025 Killian Hill Rd Lilburn GA · +1 (404) 453-6512
          </p>
        </div>
      </div>

      {related.length > 0 && (
        <section className="section" style={{ paddingTop: 0 }}>
          <div className="container">
            <div className="section-head">
              <div>
                <h2>You may also like</h2>
              </div>
            </div>
            <div className="product-grid">
              {related.map((p) => (
                <ProductCard key={p.id} product={p} />
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
}
